const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

export interface SubmitDemoRequestPayload {
  full_name: string;
  email: string;
  phone: string;
  company_name?: string;
  source?: string;
  kvkk_onay: boolean;
  notify_ops?: boolean;
  honeypot?: string;
}

export interface SubmitDemoRequestResponse {
  success: boolean;
  duplicate?: boolean;
  message?: string;
  request_id?: string;
  error?: string;
}

export async function submitDemoRequest(payload: SubmitDemoRequestPayload): Promise<SubmitDemoRequestResponse> {
  const requestUrl = `${supabaseUrl}/functions/v1/submit-demo-request`;
  const response = await fetch(`${supabaseUrl}/functions/v1/submit-demo-request`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      apikey: supabaseAnonKey,
      Authorization: `Bearer ${supabaseAnonKey}`,
    },
    body: JSON.stringify(payload),
  });

  const responseText = await response.text();
  let data: SubmitDemoRequestResponse = { success: false };

  try {
    data = responseText ? JSON.parse(responseText) as SubmitDemoRequestResponse : { success: false };
  } catch (parseError) {
    console.error('[demoRequestPublicService] Response parse error', {
      requestUrl,
      status: response.status,
      responseText,
      parseError,
    });
    throw new Error('Demo talebi servisi gecersiz yanit dondu.');
  }

  if (!response.ok) {
    console.error('[demoRequestPublicService] Request failed', {
      requestUrl,
      status: response.status,
      payload: {
        ...payload,
        honeypot: payload.honeypot ? '[filled]' : '',
      },
      data,
    });
    throw new Error(data.error || 'Demo talebi gonderilemedi.');
  }

  return data;
}
